import { forwardRef } from 'react';

import { cn } from '@/lib/utils';

export interface SeasonShareData {
  seasonNumber: number;
  junk: {
    numberOfTokens: number;
    recycledCredits: number;
    pointsRewards: number;
  };
  chest: {
    numberOfChestOpened: number;
    creditsRewarded: number;
    pointsRewards: number;
  };
  referral: {
    numberOfReferral: number;
    referralPointsRewarded: number;
    pointsRewards: number;
  };
  pointsLottery: {
    seasonPointsSpent: number;
    creditsRewards: number;
    seasonNFT: number;
  };
  summary: {
    totalPointsRewards: number;
    totalCreditsRewards: number;
  };
}

interface SeasonShareCardProps {
  data: SeasonShareData;
  className?: string;
}

export const SeasonShareCard = forwardRef<HTMLDivElement, SeasonShareCardProps>(
  ({ data, className }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('relative overflow-hidden', className)}
        style={{
          width: 558,
          height: 495,
          background: '#1B1B1B',
          boxShadow: '5px 4px 50px rgba(0, 0, 0, 0.75)',
          borderRadius: 10,
          border: '2px solid #50E4F9',
        }}
      >
        {/* Background image */}
        <img
          src="/Plano Futurista em Ciano.png"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
          style={{
            borderRadius: 10,
            zIndex: 0,
          }}
        />

        {/* Background watermark - Certified Junk logo */}
        <img
          src="/CertifiedJunkie.svg"
          alt=""
          className="absolute opacity-100"
          style={{
            width: 367,
            height: 367,
            left: 180,
            top: 45,
            transform: 'rotate(-5deg)',
            transformOrigin: 'center',
            mixBlendMode: 'lighten',
            zIndex: 0,
          }}
        />

        {/* Header */}
        <div className="relative pt-3 px-5 flex items-center" style={{ zIndex: 1 }}>
          {/* Star icon */}
          <div
            style={{
              width: 17,
              height: 17,
              marginRight: 9,
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 22 22" fill="none">
              <path d="M7.86847 3.74922C9.26177 1.24974 9.9584 0 11 0C12.0416 0 12.7382 1.24973 14.1315 3.74921L14.4919 4.39586C14.8879 5.10613 15.0858 5.46128 15.3946 5.6956C15.7033 5.92992 16.0876 6.0169 16.8565 6.19086L17.5565 6.34924C20.2621 6.96143 21.615 7.26751 21.9368 8.30252C22.2587 9.33747 21.3365 10.416 19.4919 12.5729L19.0147 13.1309C18.4905 13.7439 18.2284 14.0503 18.1105 14.4295C17.9927 14.8087 18.0323 15.2175 18.1115 16.0354L18.1836 16.7799C18.4625 19.6577 18.602 21.0966 17.7594 21.7363C16.9167 22.3759 15.65 21.7927 13.1167 20.6263L12.4613 20.3245C11.7415 19.9931 11.3816 19.8273 11 19.8273C10.6184 19.8273 10.2585 19.9931 9.53864 20.3245L8.88326 20.6263C6.34994 21.7927 5.08329 22.3759 4.24066 21.7363C3.39803 21.0966 3.53747 19.6577 3.81634 16.7799L3.88847 16.0354C3.96773 15.2175 4.00735 14.8087 3.88944 14.4295C3.77155 14.0503 3.50947 13.7439 2.98531 13.1309L2.50811 12.5729C0.663576 10.416 -0.258696 9.33747 0.0631641 8.30252C0.385024 7.26751 1.73785 6.96143 4.44349 6.34924L5.14347 6.19086C5.91233 6.0169 6.29676 5.92992 6.60543 5.6956C6.9141 5.46128 7.11208 5.10614 7.50801 4.39586L7.86847 3.74922Z" fill="url(#paint0_linear_1574_853)"/>
              <defs>
                <linearGradient id="paint0_linear_1574_853" x1="-26.95" y1="-11.55" x2="31.4727" y2="-16.2723" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#FB8B00"/>
                  <stop offset="0.264423" stopColor="#F6DF6F"/>
                  <stop offset="0.509615" stopColor="#FB8B00"/>
                  <stop offset="0.711538" stopColor="#F6DF6F"/>
                  <stop offset="1" stopColor="#FB8B00"/>
                </linearGradient>
              </defs>
            </svg>
          </div>

          {/* Title */}
          <div className="flex items-baseline gap-2">
            <span
              style={{
                color: 'white',
                fontSize: 24,
                fontFamily: 'Hyperspace Race Capsule, sans-serif',
                lineHeight: '24px',
              }}
            >
              Junk
            </span>
            <span
              style={{
                color: 'white',
                fontSize: 24,
                fontFamily: 'Outfit, sans-serif',
                fontWeight: '200',
                lineHeight: '24px',
              }}
            >
              Season {data.seasonNumber}
            </span>
          </div>
        </div>

        {/* JUNK Section */}
        <div className="relative" style={{ marginTop: 18, zIndex: 1 }}>
          {/* Gradient bar */}
          <div
            style={{
              width: 241,
              height: 15,
              background: 'linear-gradient(90deg, #50E4F9 0%, #50E4F9 69%, rgba(80, 228, 249, 0) 100%)',
            }}
          />

          {/* Icon */}
          <div
            className="absolute flex items-center justify-center"
            style={{
              width: 26,
              height: 26,
              left: 16,
              top: -5,
              background: '#1B1B1B',
              borderRadius: 9999,
              outline: '2px #50E4F9 solid',
              zIndex: 1,
            }}
          >
            {/* Trash icon */}
            <svg width="15" height="15" viewBox="0 0 26 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.18884 5.30615H23.6926" stroke="white" strokeWidth="3.30385" strokeLinecap="round"/>
              <path d="M6.79681 5.30585H6.96748C8.38132 5.30585 9.52745 4.15972 9.52745 2.74588C9.52745 2.46312 9.75668 2.23389 10.0394 2.23389H15.8421C16.1248 2.23389 16.354 2.46312 16.354 2.74588C16.354 4.15972 17.5001 5.30585 18.914 5.30585H19.0847" stroke="white" strokeWidth="3.30385"/>
              <path d="M22.1567 11.4497L20.9727 25.6562C20.7738 28.0444 18.7773 29.8815 16.3808 29.8815H9.50079C7.10424 29.8815 5.10777 28.0444 4.90876 25.6562L3.72488 11.4497" stroke="white" strokeWidth="3.30385" strokeLinecap="round"/>
            </svg>
          </div>

          {/* Label */}
          <div
            className="absolute"
            style={{
              left: 48,
              top: 2,
              color: '#1B1B1B',
              fontSize: 13,
              fontFamily: 'Hyperspace Race Capsule, sans-serif',
              textTransform: 'uppercase',
              lineHeight: '12px',
            }}
          >
            Junk
          </div>

          {/* Stats */}
          <div className="absolute" style={{ left: 42, top: 25, fontFamily: 'Outfit, sans-serif', zIndex: 1 }}>
            <div className="flex flex-col gap-1.5">
              <div className="flex items-start gap-1.5">
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>Number of Tokens:</div>
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>{data.junk.numberOfTokens}</div>
              </div>
              <div className="flex items-start gap-1.5">
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>Recycled Credits:</div>
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>{data.junk.recycledCredits}</div>
              </div>
              <div className="flex items-start gap-1.5">
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>Points Rewards:</div>
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>{data.junk.pointsRewards}</div>
              </div>
            </div>
          </div>
        </div>

        {/* CHEST Section */}
        <div className="relative" style={{ marginTop: 68, zIndex: 1 }}>
          {/* Gradient bar */}
          <div
            style={{
              width: 241,
              height: 15,
              background: 'linear-gradient(90deg, #50E4F9 0%, #50E4F9 69%, rgba(80, 228, 249, 0) 100%)',
            }}
          />

          {/* Icon */}
          <div
            className="absolute flex items-center justify-center"
            style={{
              width: 26,
              height: 26,
              left: 16,
              top: -5,
              background: '#1B1B1B',
              borderRadius: 9999,
              outline: '2px #50E4F9 solid',
              zIndex: 1,
            }}
          >
            {/* Chest icon */}
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 21 21" fill="none">
              <path d="M15.3526 0C16.683 0 17.9591 0.529003 18.8999 1.46975C19.8407 2.41052 20.3696 3.68657 20.3696 5.01702C20.3696 5.17874 20.3354 5.33872 20.2702 5.48668L18.877 8.64482H19.2054C19.8482 8.64482 20.3696 9.16626 20.3696 9.80909V19.6087C20.3696 20.2515 19.8481 20.7722 19.2054 20.7722H1.16427C0.521487 20.7722 7.326e-05 20.2515 0 19.6087V9.80909C0 9.16626 0.521441 8.64482 1.16427 8.64482H1.49264L0.0994565 5.48668C0.034181 5.33872 2.8782e-05 5.17874 0 5.01702C0 3.68657 0.52897 2.41052 1.46975 1.46975C2.41052 0.52897 3.68657 0 5.01703 0H15.3526ZM2.32854 18.4444H18.0419V10.9726H17.0955C17.0842 10.9726 17.0728 10.9729 17.0615 10.9726H12.908V12.8149L12.9041 12.9491C12.8889 13.261 12.8201 13.5684 12.7004 13.8576C12.5637 14.1881 12.3637 14.4887 12.1108 14.7417C11.8579 14.9946 11.5573 15.1953 11.2267 15.3321C10.8964 15.4688 10.5423 15.5382 10.1848 15.5381C9.46304 15.5381 8.77083 15.252 8.26041 14.7417C7.74996 14.2312 7.46318 13.5383 7.46318 12.8165V10.9726H3.30811C3.29678 10.9729 3.28547 10.9726 3.27417 10.9726H2.32854V18.4444ZM4.03746 8.64482H16.333L17.4199 6.18051H2.94975L4.03746 8.64482ZM5.01703 2.32854C4.30397 2.32854 3.61972 2.6113 3.11551 3.11551C2.89903 3.33199 2.72385 3.58195 2.59376 3.85275H17.7759C17.6458 3.58197 17.4706 3.33198 17.2541 3.11551C16.7499 2.61134 16.0656 2.32854 15.3526 2.32854H5.01703ZM9.79094 12.8165C9.79094 12.9209 9.83242 13.0212 9.90618 13.0951C9.98006 13.169 10.0811 13.2111 10.1856 13.2111C10.2373 13.2112 10.2886 13.2009 10.3364 13.1811C10.3842 13.1613 10.4276 13.1317 10.4642 13.0951C10.5008 13.0585 10.5297 13.015 10.5495 12.9672C10.5693 12.9194 10.5795 12.8682 10.5795 12.8165V10.9726H9.79094V12.8165Z" fill="white"/>
            </svg>
          </div>

          {/* Label */}
          <div
            className="absolute"
            style={{
              left: 48,
              top: 2,
              color: '#1B1B1B',
              fontSize: 13,
              fontFamily: 'Hyperspace Race Capsule, sans-serif',
              textTransform: 'uppercase',
              lineHeight: '12px',
            }}
          >
            Chest
          </div>

          {/* Stats */}
          <div className="absolute" style={{ left: 42, top: 25, fontFamily: 'Outfit, sans-serif', zIndex: 1 }}>
            <div className="flex flex-col gap-1.5">
              <div className="flex items-start gap-1.5">
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>Number of Chest Opened:</div>
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>{data.chest.numberOfChestOpened}</div>
              </div>
              <div className="flex items-start gap-1.5">
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>Credits Rewarded:</div>
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>{data.chest.creditsRewarded}</div>
              </div>
              <div className="flex items-start gap-1.5">
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>Points Rewards:</div>
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>{data.chest.pointsRewards}</div>
              </div>
            </div>
          </div>
        </div>

        {/* REFERRAL Section */}
        <div className="relative" style={{ marginTop: 68, zIndex: 1 }}>
          {/* Gradient bar */}
          <div
            style={{
              width: 241,
              height: 15,
              background: 'linear-gradient(90deg, #50E4F9 0%, #50E4F9 69%, rgba(80, 228, 249, 0) 100%)',
            }}
          />

          {/* Icon */}
          <div
            className="absolute flex items-center justify-center"
            style={{
              width: 26,
              height: 26,
              left: 16,
              top: -5,
              background: '#1B1B1B',
              borderRadius: 9999,
              outline: '2px #50E4F9 solid',
              zIndex: 1,
            }}
          >
            {/* Referral icon */}
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 20" fill="none">
              <path d="M9.94813 14.0115C8.94487 14.0115 7.98285 14.4106 7.27343 15.1201C6.597 15.7965 6.20371 16.7026 6.16848 17.6551H13.7285C13.6933 16.7026 13.2999 15.7965 12.6236 15.1201C11.9141 14.4106 10.9515 14.0115 9.94813 14.0115ZM15.6933 8.96758V8.12669H14.8524C14.2334 8.12659 13.7314 7.62476 13.7314 7.00574C13.7315 6.3868 14.2334 5.88489 14.8524 5.88479H15.6933V5.0439C15.6935 4.42498 16.1952 3.92295 16.8142 3.92295C17.4332 3.92296 17.935 4.42499 17.9352 5.0439V5.88479H18.776C19.395 5.88489 19.8969 6.3868 19.897 7.00574C19.897 7.62476 19.395 8.12658 18.776 8.12669H17.9352V8.96758C17.9352 9.58666 17.4333 10.0885 16.8142 10.0885C16.1951 10.0885 15.6933 9.58666 15.6933 8.96758ZM19.897 17.7948C19.897 18.3522 19.675 18.8867 19.2809 19.2809C18.8867 19.675 18.3522 19.897 17.7948 19.897H2.1015C1.54418 19.8969 1.00949 19.675 0.615394 19.2809C0.221402 18.8867 0 18.3521 0 17.7948V2.1015C7.21257e-05 1.54418 0.221298 1.00949 0.615394 0.615394L0.769606 0.47573C1.14353 0.169362 1.61387 6.31068e-05 2.1015 0H16.8142C17.4333 3.35923e-06 17.9352 0.501867 17.9352 1.12095C17.9352 1.74003 17.4333 2.24189 16.8142 2.24189H2.24189V17.6551H3.92659C3.9625 16.1079 4.59077 14.6312 5.68766 13.5343C5.97642 13.2455 6.29176 12.9894 6.62748 12.7676C6.21007 12.4033 5.85393 11.9712 5.57491 11.4873C5.13247 10.7201 4.8993 9.84961 4.89987 8.96394C4.90049 8.07838 5.13446 7.20858 5.57782 6.44199C6.02125 5.67532 6.65877 5.03869 7.42618 4.59654C8.19338 4.15454 9.06346 3.92216 9.94886 3.92295C10.38 3.92006 10.8096 3.9763 11.2255 4.09026C11.8225 4.25388 12.174 4.87091 12.0104 5.46798C11.8467 6.06501 11.2297 6.41648 10.6326 6.25286C10.413 6.1927 10.186 6.16281 9.95832 6.16485C9.95468 6.16488 9.95105 6.16485 9.94741 6.16485C9.45543 6.16434 8.97198 6.29388 8.54568 6.53947C8.11934 6.7851 7.76491 7.13847 7.51857 7.56439C7.27226 7.99025 7.14212 8.47344 7.14177 8.9654C7.14145 9.4573 7.27071 9.94096 7.51638 10.3671C7.76213 10.7933 8.11615 11.1473 8.54204 11.3935C8.96807 11.6397 9.45173 11.7695 9.94377 11.7696C10.4358 11.7697 10.9194 11.6402 11.3455 11.3942C11.7715 11.1483 12.1252 10.7946 12.3712 10.3686C12.6807 9.83248 13.3662 9.64888 13.9024 9.95832C14.4385 10.2679 14.6222 10.9534 14.3126 11.4895C14.0344 11.9714 13.6793 12.4014 13.2637 12.7647C13.6013 12.9872 13.9184 13.2441 14.2086 13.5343C15.3055 14.6312 15.9338 16.1079 15.9697 17.6551H17.6551V12.8905C17.6553 12.2716 18.1571 11.7696 18.776 11.7696C19.3949 11.7697 19.8968 12.2717 19.897 12.8905V17.7948Z" fill="white"/>
            </svg>
          </div>

          {/* Label */}
          <div
            className="absolute"
            style={{
              left: 48,
              top: 2,
              color: '#1B1B1B',
              fontSize: 13,
              fontFamily: 'Hyperspace Race Capsule, sans-serif',
              textTransform: 'uppercase',
              lineHeight: '12px',
            }}
          >
            referral
          </div>

          {/* Stats */}
          <div className="absolute" style={{ left: 42, top: 25, fontFamily: 'Outfit, sans-serif', zIndex: 1 }}>
            <div className="flex flex-col gap-1.5">
              <div className="flex items-start gap-1.5">
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>Number of Referral:</div>
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>{data.referral.numberOfReferral}</div>
              </div>
              <div className="flex items-start gap-1.5">
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>Referral Points Rewarded:</div>
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>{data.referral.referralPointsRewarded}</div>
              </div>
              <div className="flex items-start gap-1.5">
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>Points Rewards:</div>
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>{data.referral.pointsRewards}</div>
              </div>
            </div>
          </div>
        </div>

        {/* POINTS LOTTERY Section */}
        <div className="relative" style={{ marginTop: 68, zIndex: 1 }}>
          {/* Gradient bar */}
          <div
            style={{
              width: 241,
              height: 15,
              background: 'linear-gradient(90deg, #50E4F9 0%, #50E4F9 69%, rgba(80, 228, 249, 0) 100%)',
            }}
          />

          {/* Icon */}
          <div
            className="absolute flex items-center justify-center"
            style={{
              width: 26,
              height: 26,
              left: 16,
              top: -5,
              background: '#1B1B1B',
              borderRadius: 9999,
              outline: '2px #50E4F9 solid',
              zIndex: 1,
            }}
          >
            {/* Points Lottery icon (clover) */}
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 21 21" fill="none">
              <path d="M17.8682 11.4868C16.9242 11.3239 15.009 11.0095 14.0392 10.8486C13.6387 10.7821 13.4011 10.5693 13.4011 10.2104C13.4011 9.85789 13.6387 9.63868 14.0392 9.57219C15.009 9.41126 16.9242 9.09689 17.8682 8.93404C19.182 8.70737 20.2823 7.95933 20.4088 6.63208C20.554 5.1096 19.3607 3.82877 17.8682 3.82877H17.7585C17.1142 3.82877 16.5919 3.30644 16.5919 2.66218C16.5919 1.32895 15.6171 0.138346 14.29 0.0117912C12.7675 -0.13339 11.7432 1.08218 11.4866 2.55246C11.3196 3.50969 10.9986 5.42676 10.8485 6.3814C10.7836 6.79354 10.5628 7.01956 10.2103 7.01956C9.85134 7.01956 9.63696 6.79354 9.57214 6.3814C9.42202 5.42676 9.10098 3.50969 8.93398 2.55246C8.67745 1.08214 7.65312 -0.13339 6.13064 0.0117912C4.80347 0.138306 3.82872 1.32891 3.82872 2.66214C3.82872 3.3064 3.30639 3.82877 2.66213 3.82877H2.5524C1.05987 3.82877 -0.133403 5.1096 0.0117378 6.63208C0.138293 7.95933 1.2386 8.70737 2.5524 8.93404C3.49636 9.09689 5.41163 9.41126 6.38135 9.57219C6.78188 9.63868 7.01951 9.85789 7.01951 10.2104C7.01951 10.5693 6.78188 10.7821 6.38135 10.8486C5.41163 11.0095 3.49636 11.3239 2.5524 11.4868C1.2386 11.7135 0.138293 12.4615 0.0117378 13.7887C-0.133443 15.3111 1.05983 16.5919 2.5524 16.5919H2.66213C3.30639 16.5919 3.82872 17.1144 3.82872 17.7587V17.7587C3.82872 19.092 4.80343 20.2825 6.13064 20.4091C7.65312 20.5543 8.67745 19.3387 8.93398 17.8684C9.10102 16.9112 9.42202 14.9941 9.57214 14.0395C9.63696 13.6273 9.85134 13.4013 10.2103 13.4013C10.5693 13.4013 10.7836 13.6273 10.8485 14.0395C10.9986 14.9941 11.3196 16.9112 11.4866 17.8684C11.7432 19.3387 12.7675 20.5543 14.29 20.4091C15.6172 20.2826 16.5919 19.092 16.5919 17.7587V17.7587C16.5919 17.1144 17.1142 16.5919 17.7585 16.5919H17.8682C19.3607 16.5919 20.554 15.3111 20.4088 13.7887C20.2823 12.4615 19.182 11.7135 17.8682 11.4868Z" fill="white"/>
            </svg>
          </div>

          {/* Label */}
          <div
            className="absolute"
            style={{
              left: 48,
              top: 2,
              color: '#1B1B1B',
              fontSize: 13,
              fontFamily: 'Hyperspace Race Capsule, sans-serif',
              textTransform: 'uppercase',
              lineHeight: '12px',
            }}
          >
            Points Lottery
          </div>

          {/* Stats */}
          <div className="absolute" style={{ left: 42, top: 25, fontFamily: 'Outfit, sans-serif', zIndex: 1 }}>
            <div className="flex flex-col gap-1.5">
              <div className="flex items-start gap-1.5">
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>Season Points Spent:</div>
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>{data.pointsLottery.seasonPointsSpent}</div>
              </div>
              <div className="flex items-start gap-1.5">
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>Credits Rewards:</div>
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>{data.pointsLottery.creditsRewards}</div>
              </div>
              <div className="flex items-start gap-1.5">
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>Season NFT:</div>
                <div style={{ color: '#D6D6D6', fontSize: 13, lineHeight: '13px' }}>{data.pointsLottery.seasonNFT}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Gold SUMMARY Section */}
        <div className="absolute" style={{ width: 558, height: 22, top: 398, left: 0, zIndex: 1 }}>
          <div
            style={{
              width: '100%',
              height: 22,
              background: 'linear-gradient(138deg, #FB8B00 0%, #F6DF6F 26%, #FB8B00 51%, #F6DF6F 71%, #FB8B00 100%)',
            }}
          />

          {/* Icon */}
          <div
            className="absolute flex items-center justify-center"
            style={{
              width: 32,
              height: 32,
              left: 20,
              top: -5,
              background: '#1B1B1B',
              borderRadius: 9999,
              outline: '2.6px #FB8B00 solid',
            }}
          >
            {/* Document/Summary icon */}
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 23 27" fill="none">
              <path d="M20.73 3.33H14.97L14.94 3.12C14.86 2.24 14.49 1.5 13.83 0.9C13.17 0.3 12.39 0 11.49 0C10.59 0 9.81 0.3 9.15 0.9C8.49 1.5 8.12 2.24 8.04 3.12L8.01 3.33H2.25C1.63 3.33 1.1 3.55 0.66 3.99C0.22 4.43 0 4.96 0 5.58V24.06C0 24.68 0.22 25.215 0.66 25.665C1.1 26.115 1.63 26.34 2.25 26.34H20.73C21.35 26.34 21.88 26.115 22.32 25.665C22.76 25.215 22.98 24.68 22.98 24.06V5.61C22.98 4.97 22.76 4.43 22.32 3.99C21.88 3.55 21.35 3.33 20.73 3.33ZM11.49 2.1C11.85 2.1 12.16 2.23 12.42 2.49C12.68 2.75 12.81 3.065 12.81 3.435C12.81 3.805 12.68 4.12 12.42 4.38C12.16 4.64 11.85 4.77 11.49 4.77C11.13 4.77 10.82 4.64 10.56 4.38C10.3 4.12 10.17 3.805 10.17 3.435C10.17 3.065 10.3 2.75 10.56 2.49C10.82 2.23 11.13 2.1 11.49 2.1ZM12.42 20.43H5.4C5.24 20.43 5.1 20.375 4.98 20.265C4.86 20.155 4.8 20.02 4.8 19.86V18.42C4.8 18.26 4.86 18.125 4.98 18.015C5.1 17.905 5.24 17.85 5.4 17.85H12.42C12.58 17.85 12.72 17.905 12.84 18.015C12.96 18.125 13.02 18.26 13.02 18.42V19.86C13.02 20.02 12.96 20.155 12.84 20.265C12.72 20.375 12.58 20.43 12.42 20.43ZM17.58 15.93H5.4C5.24 15.93 5.1 15.875 4.98 15.765C4.86 15.655 4.8 15.52 4.8 15.36V13.92C4.8 13.76 4.86 13.62 4.98 13.5C5.1 13.38 5.24 13.32 5.4 13.32H17.58C17.74 13.32 17.88 13.38 18 13.5C18.12 13.62 18.18 13.76 18.18 13.92V15.36C18.18 15.52 18.12 15.655 18 15.765C17.88 15.875 17.74 15.93 17.58 15.93ZM17.58 11.43H5.4C5.24 11.43 5.1 11.375 4.98 11.265C4.86 11.155 4.8 11.01 4.8 10.83V9.42C4.8 9.26 4.86 9.12 4.98 9C5.1 8.88 5.24 8.82 5.4 8.82H17.58C17.74 8.82 17.88 8.88 18 9C18.12 9.12 18.18 9.26 18.18 9.42V10.83C18.18 11.01 18.12 11.155 18 11.265C17.88 11.375 17.74 11.43 17.58 11.43Z" fill="url(#paint0_linear_1574_2015)"/>
              <defs>
                <linearGradient id="paint0_linear_1574_2015" x1="-0.881239" y1="-2.26359" x2="24.6627" y2="-1.38489" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#FB8B00"/>
                  <stop offset="0.264423" stopColor="#F6DF6F"/>
                  <stop offset="0.509615" stopColor="#FB8B00"/>
                  <stop offset="0.711538" stopColor="#F6DF6F"/>
                  <stop offset="1" stopColor="#FB8B00"/>
                </linearGradient>
              </defs>
            </svg>
          </div>

          {/* Label */}
          <div
            className="absolute"
            style={{
              left: 59,
              top: 4,
              color: '#1B1B1B',
              fontSize: 14,
              fontFamily: 'Hyperspace Race Capsule, sans-serif',
              textTransform: 'uppercase',
              lineHeight: '14px',
            }}
          >
            SUMMARY
          </div>
        </div>

        {/* Summary Stats */}
        <div className="absolute" style={{ left: 40, top: 431, zIndex: 1 }}>
          <div className="flex flex-col gap-3">
            <div className="flex items-start gap-2">
              <div style={{ color: 'white', fontSize: 18, fontFamily: 'Outfit, sans-serif', lineHeight: '18px' }}>
                Total Points Rewards:
              </div>
              <div
                style={{
                  fontSize: 18,
                  fontFamily: 'Outfit, sans-serif',
                  fontWeight: '700',
                  lineHeight: '18px',
                  background: 'linear-gradient(92deg, #FB8B00 -4.02%, #F6DF6F 24.3%, #FB8B00 50.55%, #F6DF6F 72.17%, #FB8B00 103.05%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                {data.summary.totalPointsRewards.toLocaleString()}
              </div>
            </div>
            <div className="flex items-start gap-2">
              <div style={{ color: 'white', fontSize: 18, fontFamily: 'Outfit, sans-serif', lineHeight: '18px' }}>
                Total Credits Rewards:
              </div>
              <div
                style={{
                  fontSize: 18,
                  fontFamily: 'Outfit, sans-serif',
                  fontWeight: '700',
                  lineHeight: '18px',
                  background: 'linear-gradient(92deg, #FB8B00 -4.02%, #F6DF6F 24.3%, #FB8B00 50.55%, #F6DF6F 72.17%, #FB8B00 103.05%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                {data.summary.totalCreditsRewards}
              </div>
            </div>
          </div>
        </div>

        {/* JUNK.FUN Branding */}
        <div className="absolute" style={{ right: 23, top: 441, zIndex: 1 }}>
          <img src="/logo.svg" alt="JUNK.FUN" style={{ width: 99, height: 'auto' }} />
        </div>
      </div>
    );
  }
);

SeasonShareCard.displayName = 'SeasonShareCard';
